import PropTypes from "prop-types";
import CloseIcon from "../../assets/icons/close.svg";
import BackIcon from "../../assets/icons/back_arrow.svg";
import styles from "./FavouritesHeader.module.scss";

export const FavouritesHeader = ({
  heading,
  children = null,
  goBack = null,
  close = () => {},
}) => {
  return (
    <header className={styles.filterHeader}>
      <div className={styles.filterHeaderContainer}>
        {goBack !== null && (
          <button type="button" aria-label="Go back" onClick={goBack}>
            <img src={BackIcon} alt="Go back to my favourites" />
          </button>
        )}
        <h3 className={styles.filterName}>{heading}</h3>
        <button
          type="button"
          aria-label="Close filter view"
          className={styles.filterCloseButton}
          onClick={close}
        >
          <img src={CloseIcon} alt="Close" />
        </button>
      </div>
      {children !== null && children}
    </header>
  );
};

FavouritesHeader.propTypes = {
  heading: PropTypes.string.isRequired,
  close: PropTypes.func.isRequired,
  children: PropTypes.node,
  goBack: PropTypes.func,
};
